import { PageHeader } from "@finitless/shared/components";
import { Button } from "../../../ui/UIElements/Button";
import React from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Icon } from "../../../ui/UIElements/Icon";
import CartRecoveryForm from "./CartRecoveryForm";
import "./cart-recovery-ordering.css";

const CartRecoveryCreatePage = () => {
  const { t } = useTranslation("cartRecovery");
  const navigate = useNavigate();

  const handleBack = () => {
    navigate("/growth/cart-recovery");
  };

  const handleCreated = (created) => {
    const id = created?.id ?? created?.result?.id;
    if (id) {
      navigate(`/growth/cart-recovery/${id}`);
      return;
    }
    handleBack();
  };

  return (
    <div
      className="ordering-cart-recovery-surface space-y-6"
      data-ordering-expression="product"
    >
      <div className="flex min-w-0 items-start gap-4 [&>div]:min-w-0 [&>div]:flex-1">
        <Button
          emphasis="ghost"
          intent="neutral"
          size="iconTouch"
          type="button"
          onClick={handleBack}
          className="shrink-0"
          aria-label={t("create.back")}
        >
          <Icon name="ArrowLeft" className="text-muted-foreground h-5 w-5" />
        </Button>
        <PageHeader title={t("create.title")} subtitle={t("create.subtitle")} />
      </div>

      <CartRecoveryForm
        mode="create"
        onCancel={handleBack}
        onSuccess={handleCreated}
      />
    </div>
  );
};

export default CartRecoveryCreatePage;
